import React, {useState, useEffect} from "react";
// Components
import ClientSlider from "../Elements/ClientSlider";
import XhoshaLogo from "../../assets/img/logo.png";

export default function AboutUs() {

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        function handleWindowSizeChange() {
            setIsMobile(window.innerWidth < 768);
        }
        window.addEventListener('resize', handleWindowSizeChange);
        handleWindowSizeChange();
        return () => window.removeEventListener('resize', handleWindowSizeChange);
    }, []);

    return (
        <section id="about-us" className="w-full">
            <div className="bg-white text-center py-8">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="w-full">
                        <img src={XhoshaLogo} className={isMobile ? 'w-4/5 mx-auto' : 'w-2/5 mx-auto'} alt="Xhosha Logo" />
                    </div>
                    <div className="mt-6 mb-4">
                        <h1 className="text-2xl md:text-3xl font-extrabold">Wir bieten perfekten Service für Unternehmen und Privatkunden.</h1>
                        <h4 className="text-sm md:text-base font-semibold mt-4">Wir bieten branchenweit unschlagbaren Service. Unser Ziel sind perfekte Ergebnisse und die Zufriedenheit unserer Kunden hat stets höchste Priorität. Darauf sind wir stolz. </h4>
                    </div>
                </div>
            </div>
            <div className="bg-gray-100 py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <ClientSlider />
                </div>
            </div>
        </section>
    );
}
